export const MOUSEOVER_TRIGGER = "data-profile-popover";
export const LEADERBOARD_ID = "leaderboard_container";
export const POPOVER_WIDTH = 400;
export const POPOVER_HEIGHT = 136;
export const POPOVER_TO_WINDOW_GUTTER = 55;
export const ARROW_GUTTER = 70;
export const OPEN_DELAY = 400;
export const LOAD_DELAY = 150;



// WEBPACK FOOTER //
// ./src/shared/components/ProfileQuickview/util/constants.js